// The supporter state this browser last heard from the server (docs/SUPPORTERS.md 8).
//
// Display only: every perk that matters is checked on the server. The copy in localStorage keeps
// perks from flickering on load, and it is never part of a savefile or cloud backup
// (shared/backup.js NO_SYNC_KEYS), because a restored blob must not carry someone's pass.

export const SUPPORTER_KEY = "revault:supporter";
export const LAST_FREE_LOOK_KEY = "revault:lastFreeLook";

export const FREE = Object.freeze({
	earlyLooks: false, signatureLooks: false, wallpaperSlots: 1, hallFlair: false, hallBadge: "",
	tabSessions: false, restorePoints: 0, preview: false, votes: false, patronVotes: false,
	noAdCards: false, helperTurnsMultiplier: 1,
});

export function readCached() {
	try {
		const j = JSON.parse(localStorage.getItem(SUPPORTER_KEY) || "null");
		return j && typeof j === "object" ? j : null;
	} catch (e) { void e; return null; }
}

// Perks from the cached state, but only while that state can still be true: a lifetime pass, or
// a pass whose grace period hasn't ended yet.
export function cachedPerks(now = Date.now()) {
	const j = readCached();
	if (!j || !j.perks) return { ...FREE };
	if (j.status === "lifetime") return { ...FREE, ...j.perks };
	if ((j.status === "active" || j.status === "grace") && Number(j.graceUntil) > now) return { ...FREE, ...j.perks };
	return { ...FREE };
}

export function writeCached(state) {
	try {
		if (!state) { localStorage.removeItem(SUPPORTER_KEY); return; }
		const keep = { status: state.status, tier: state.tier, until: state.until, graceUntil: state.graceUntil, perks: state.perks, at: Date.now() };
		localStorage.setItem(SUPPORTER_KEY, JSON.stringify(keep));
	} catch (e) { void e; }
}

// Ask the server. `fetcher` is account.js authedFetch. Returns the state or null.
export async function refresh(fetcher) {
	try {
		const r = await fetcher("/account/supporter");
		if (!r.ok) return null;
		const s = await r.json();
		writeCached(s && !s.down ? s : null);
		return s;
	} catch (e) { void e; return null; }
}

const fmt = (t) => new Date(t).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
// One plain sentence about the pass, for Settings and the Supporter page.
export function statusLine(s) {
	if (!s || s.status === "none" || !s.status) return "You don't have a pass. Everything you need to study is free.";
	if (s.status === "lifetime") return s.tier === "patron" ? "Founding supporter, with Patron until " + fmt(s.patronUntil) + ". Thank you." : "Founding supporter, for as long as Re:Vault runs. Thank you.";
	if (s.status === "grace") return "Your pass ended on " + fmt(s.until) + ". Perks stay on until " + fmt(s.graceUntil) + ".";
	if (s.tier === "patron") return "You're a Patron until " + fmt(s.patronUntil) + ". Supporter perks run until " + fmt(s.until) + ".";
	return "Your pass is on until " + fmt(s.until) + ".";
}
